(() => {
  const script = document.currentScript;
  const viewLabel = script?.dataset.viewLabel || 'View';
  const imageAlternatives = new Map([
    [
      'barnana_-_hero_january_2026.jpg',
      "Barnana Cosmic Churro, Flamin' Ghost, and Sea Salt plantain chip bags on a handcrafted tropical and outer-space set with rockets, palm trees, a volcano, beach scenery, and toy characters."
    ],
    [
      'barnana-hero-january-2026-mobile.jpg',
      "Barnana Cosmic Churro, Flamin' Ghost, and Sea Salt plantain chip bags on a handcrafted tropical and outer-space set with rockets, palm trees, a volcano, beach scenery, and toy characters."
    ],
    [
      'barnana_-_pink_salt_mobile_1_f4018857-5851-4090-93e7-75426131820d.jpg',
      'Barnana Organic Himalayan Pink Salt Plantain Chips beside a miniature farm scene with people harvesting plantains against a mountain and river backdrop.'
    ],
    ['non-gmo-project-badge.webp', 'Non-GMO Project Verified certification logo.'],
    ['organic_certification_1.png', 'USDA Organic certification logo.'],
    ['ufa-upcycledcertified-veritcal-color-rgb.png', 'Upcycled Certified certification logo.'],
    ['certified_b_corporation_b_corp_logo_2022_black_rgb_svg.png', 'Certified B Corporation logo.'],
    [
      'barnana_-_collection_image_1_copy.jpg',
      "Barnana Acapulco Lime and Himalayan Pink Salt Plantain Chips and Organic Banana and Coconut Chewy Bites around the words “Tasty better-for-you snacks.”"
    ],
    ['rectangle-41-1677555523182_1200x.png', '']
  ]);
  const enhancedTablists = new WeakSet();
  const enhancedZoomImages = new WeakSet();
  let componentId = 0;

  const filenameFor = image => {
    const source = image.currentSrc || image.src || '';
    try {
      return decodeURIComponent(source.split('/').pop().split('?')[0]).toLowerCase();
    } catch {
      return source.split('/').pop().split('?')[0].toLowerCase();
    }
  };

  const applyImageAlternatives = () => {
    document.querySelectorAll('img').forEach(image => {
      const alternative = imageAlternatives.get(filenameFor(image));
      if (alternative !== undefined) image.alt = alternative;
    });
  };

  const availableTabs = component => [...component.querySelectorAll('.tab-link[data-tab]')]
    .filter(tab => !tab.hidden && !tab.classList.contains('hidden'));

  const panelFor = (component, tab) => component.querySelector(`.tab-content-${tab.dataset.tab}`);

  const syncTabComponent = component => {
    const tablist = component.querySelector('.tabs');
    const tabs = availableTabs(component);
    if (!tablist || !tabs.length) return;

    componentId += component.dataset.barnanaAccessibilityTabs ? 0 : 1;
    component.dataset.barnanaAccessibilityTabs ||= String(componentId);
    const idBase = `BarnanaTabs-${component.dataset.barnanaAccessibilityTabs}`;
    const currentTab = tabs.find(tab => tab.classList.contains('current')) || tabs[0];

    tablist.setAttribute('role', 'tablist');
    tabs.forEach(tab => {
      const panel = panelFor(component, tab);
      if (!panel) return;
      const tabId = `${idBase}-tab-${tab.dataset.tab}`;
      const panelId = `${idBase}-panel-${tab.dataset.tab}`;
      const selected = tab === currentTab;

      tab.id ||= tabId;
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-controls', panel.id || panelId);
      tab.setAttribute('aria-selected', String(selected));
      tab.tabIndex = selected ? 0 : -1;

      panel.id ||= panelId;
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('aria-labelledby', tab.id);
      panel.setAttribute('aria-hidden', String(!selected));
    });

    component.querySelectorAll('.tab-link[data-tab].hidden').forEach(tab => {
      tab.setAttribute('aria-hidden', 'true');
      tab.tabIndex = -1;
    });

    if (enhancedTablists.has(tablist)) return;
    enhancedTablists.add(tablist);
    tablist.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      const activeTabs = availableTabs(component);
      const currentIndex = activeTabs.indexOf(document.activeElement);
      if (currentIndex < 0) return;

      event.preventDefault();
      let nextIndex;
      if (event.key === 'Home') {
        nextIndex = 0;
      } else if (event.key === 'End') {
        nextIndex = activeTabs.length - 1;
      } else {
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        nextIndex = (currentIndex + direction + activeTabs.length) % activeTabs.length;
      }
      activeTabs[nextIndex].focus();
      activeTabs[nextIndex].click();
    });
  };

  const applyTabSemantics = () => {
    document.querySelectorAll('tabs-component').forEach(syncTabComponent);
  };

  const applyProductImageKeyboardSupport = () => {
    document.querySelectorAll('.product__photo[tabindex="0"]:not([data-zoom-image])').forEach(image => {
      image.removeAttribute('tabindex');
    });

    document.querySelectorAll('[data-zoom-image]').forEach(zoomImage => {
      zoomImage.setAttribute('role', 'button');
      zoomImage.setAttribute('aria-haspopup', 'dialog');
      if (!zoomImage.hasAttribute('aria-label')) {
        const alternative = zoomImage.querySelector('img')?.alt?.trim() || 'product image';
        zoomImage.setAttribute('aria-label', `${viewLabel} ${alternative}`);
      }
      if (enhancedZoomImages.has(zoomImage)) return;
      enhancedZoomImages.add(zoomImage);
      zoomImage.addEventListener('keydown', event => {
        if (event.key === ' ') event.preventDefault();
      });
      zoomImage.addEventListener('keyup', event => {
        if (event.key !== ' ') return;
        event.preventDefault();
        zoomImage.click();
      });
    });
  };

  const enhance = () => {
    applyImageAlternatives();
    applyTabSemantics();
    applyProductImageKeyboardSupport();
  };

  let scheduled = false;
  const scheduleEnhance = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      enhance();
    });
  };

  enhance();
  ['theme:tab:change', 'theme:tab:check', 'theme:tab:hide'].forEach(eventName => {
    document.addEventListener(eventName, scheduleEnhance);
  });
  new MutationObserver(scheduleEnhance).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
